import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import { Pet, PetService } from '../service/PetService';

(window as typeof window & { Alpine: typeof Alpine }).Alpine = Alpine;

document.addEventListener('alpine:init', () => {
  const petService = new PetService();

  Alpine.data('common', function() {
    return {
    }
  })

  Alpine.data('appointmentForm', () => ({
    formData: {
      preferredDate: '',
      preferredTime: '',
      petType: '',
      breed: '',
      petName: '',
      petAge: '',
      reasonForVisit: '',
      vetName: 'Dr. Sarah Johnson'
    },
    savedPets: [] as Pet[],

    init() {
      this.savedPets = petService.getSavedPets();
    },

    selectPet(pet: Pet) {
      this.formData.petType = pet.type;
      this.formData.breed = pet.breed;
      this.formData.petName = pet.name;
      this.formData.petAge = pet.age;
    },

    async submitForm() {
      try {
        // Save pet data if it's new
        const newPet = {
          name: this.formData.petName,
          type: this.formData.petType,
          breed: this.formData.breed,
          age: this.formData.petAge
        };
        
        if (!this.savedPets.some(p => p.name === newPet.name)) {
          petService.savePet(newPet);
        }

        // POST to API
        /*
        const response = await fetch('/api/appointments', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.formData)
        });

        if (!response.ok) throw new Error('Failed to submit appointment');
      */

        // Redirect to confirmation page with form data
        const queryParams = new URLSearchParams(this.formData as any);
        window.location.href = `/confirm-request?${queryParams.toString()}`;
      } catch (error) {
        console.error('Error submitting form:', error);
        // Handle error appropriately
      }
    }
  }));
});

Alpine.start();

